import React from "react";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";
import Icon from "./icon";

import * as styles from "../styles/components/link.module.css";

interface LinkNode {
  url?: string;
  text?: string;
  blank?: boolean;
}

interface LinkElemProps extends LinkNode {
  node?: LinkNode;
  contact?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onMouseEnter?: MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: MouseEventHandler<HTMLAnchorElement>;
  theme?: string;
  icon?: string;
  noStyle: boolean;
}

const LinkElem: React.FC<LinkElemProps> = ({ 
  node,
  url,
  text,
  blank,
  contact,
  onClick,
  onMouseEnter,
  onMouseLeave,
  theme,
  icon,
  noStyle
}) => {
  // Destructure node for cleanliness
  const { url: nodeUrl, blank: nodeBlank, text: nodeText } = node || {};

  // Simplify URL and text selection
  const finalUrl = url || nodeUrl;
  const finalText = text || nodeText;
  const finalBlank = blank || nodeBlank;

  // Early return for no URL
  if (!finalUrl) return null;

  const scrollToHash = (hash) => {
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleClick = (e) => {
    if (finalUrl.startsWith("#")) {
      e.preventDefault();
      scrollToHash(finalUrl);
    } else if (onClick) {
      onClick(e);
    }
  };

  const LinkComponent: React.ElementType = (finalBlank || contact) ? 'a' : Link;

  const linkProps = {
    className: noStyle ? undefined : cn(styles.root, styles[theme]),
    onClick: handleClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ...((finalBlank || contact)
      ? { href: finalUrl, target: contact ? undefined : "_blank", rel: "noreferrer" } 
      : { to: finalUrl }),
  };

  const renderContent = () => (
    <>
      {finalText}
      <Icon symbol={icon} />
    </>
  );

  return <LinkComponent {...linkProps}>{renderContent()}</LinkComponent>;
};

export default LinkElem;
